import React, { useState, useEffect } from 'react';
import StreamList from '../components/StreamList';
import StreamViewer from '../components/StreamViewer';
import { useAuthRouting } from '../contexts/AuthRouteContext';
import { useNavigate } from 'react-router-dom';

const View = () => {
  const [selectedStreamId, setSelectedStreamId] = useState(null);
  const navigate = useNavigate();
  const { requireAuth } = useAuthRouting();

  useEffect(() => {
    console.log(selectedStreamId);
    if (selectedStreamId){
      requireAuth(() => {}, () => navigate('/login'));
    }
    
  }, [selectedStreamId , navigate, requireAuth]);

  return (
    <div>
      {!selectedStreamId ? (
        <StreamList onSelectStream={setSelectedStreamId} />
      ) : (
        <StreamViewer streamId={selectedStreamId} clearStream={() => setSelectedStreamId(null)}/>
      )}
    </div>
  );
};

export default View;
